module.exports = "/packs/done_stamp-1255aea5a4a9b076937f3abb1e21aba2.svg";